import { getCourseResourcesApiV1CoursesCourseIdResourcesGet } from "@/src/api/sdk.gen";
import type { ResourceSchema } from "@/src/api/types.gen";

/**
 * React Query key for the *whole-course* resource list. Deliberately
 * unfiltered (no module/lesson query params) so the course-detail badge
 * counts, the resource drawer, and the per-lesson resource icon all read the
 * same cache entry instead of issuing their own `/resources` request — see
 * F7 in docs/api_performance_audit.md.
 */
export const courseResourcesQueryKey = (courseId: string) => ["course-resources", courseId] as const;

export async function fetchCourseResources(courseId: string): Promise<ResourceSchema[]> {
    const { data, error } = await getCourseResourcesApiV1CoursesCourseIdResourcesGet({
        path: { course_id: courseId },
    });
    if (error) throw new Error("error");
    return data ?? [];
}
